import React from "react";
import styled from "styled-components";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#F6FAFE",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#F6FAFE",
    padding: "16px",
    color: "#444444",
    boxShadow: "0px 2px 10px 0px #00000040",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
    textAlign: "left",
    whiteSpace: "break-spaces",
  },
}));

export const TruncatedTextWithTooltip = (props) => {
  const { childrenText = [], maxValues = 3 } = props;

  const total = childrenText.length;
  const remaining = total - maxValues;
  const truncatedText = childrenText.slice(0, maxValues).join(", ");
  const tooltipText =
    total > maxValues ? childrenText.slice(3, total).join("\n") : null;
  return (
    <p>
      {truncatedText}
      {tooltipText !== null && (
        <LightTooltip title={tooltipText} placement="right-start" arrow>
          <b> (+{remaining})</b>
        </LightTooltip>
      )}
    </p>
  );
};
